var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"addNewButton",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"mainText"},[_vm._v(_vm._s(_vm.main_text))]),_c('span',{staticClass:"subText"},[_vm._v(_vm._s(_vm.sub_text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }